<div class="nav-bar-wrapper">
  <mat-drawer-container #drawer class="dashboard-drawer-container">
    @let firstName = firstName$ | async;
    <mat-toolbar *ngIf="!useMobileLayout" class="dashboard-toolbar" [ngStyle]="{ height: 'var(--nav-bar-height)' }">
      <mat-nav-list class="list-horizontal">
        @if (environment.backToShopLink) {
        <a
          mat-list-item
          class="left-placeholder outer-menu-buttons left-leaning"
          href="{{ environment.backToShopLink }}"
        >
          <mat-icon class="back-link-icon logout-text">shopping_cart</mat-icon>
          {{ 'GENERAL.BACK_TO_SHOP' | translate }}</a
        >
        } @else {
        <div mat-list-item class="left-placeholder left-leaning" [style.width.px]="width"></div>
        }
        <div class="logo">
          @if (c4SessionId) {
          <span mat-list-item class="image-container">
            <a routerLink="/navigation"><img [src]="'assets/img/' + logo" alt="logo" /></a>
          </span>
          } @else {
          <img [src]="'assets/img/' + logo" alt="logo" />
          }
        </div>
        @if (isLoggedIn) {
        <a
          mat-list-item
          #logoutButton
          id="logout-button"
          class="right-placeholder outer-menu-buttons right-leaning"
          (click)="logout()"
        >
          @if (firstName) {
          <span id="name-text" matListItemTitle>Hallo, {{ firstName }}</span>
          }
          <span matListItemLine>
            <span class="logout-text">{{ 'GENERAL.LOGOUT' | translate }}</span>
            <mat-icon>exit_to_app</mat-icon>
          </span>
        </a>
        }
      </mat-nav-list>
    </mat-toolbar>
    <mat-toolbar *ngIf="useMobileLayout" class="mobile-dashboard-toolbar">
      <mat-nav-list class="list-horizontal">
        <a
          *ngIf="isLoggedIn"
          mat-list-item
          class="outer-menu-buttons"
          (click)="drawer.open()"
          [disabled]="!c4SessionId"
        >
          <mat-icon>menu</mat-icon>
        </a>
        <div mat-list-item class="logo">
          @if (c4SessionId) {
          <a routerLink="/navigation"><img [src]="'assets/img/' + logo" alt="logo" /></a>
          } @else {
          <img [src]="'assets/img/' + logo" alt="logo" />
          }
        </div>
        <a *ngIf="isLoggedIn" mat-list-item (click)="logout()" class="outer-menu-buttons logout-buttons">
          <span matListItemTitle>
            @if (firstName) {
            <span id="name-text">Hallo, {{ firstName }}</span>
            }
            <mat-icon>exit_to_app</mat-icon>
          </span>
        </a>
      </mat-nav-list>
    </mat-toolbar>
    <router-outlet></router-outlet>
    <mat-drawer mode="over">
      <button class="close-button" mat-icon-button (click)="drawer.close()">
        <mat-icon>close</mat-icon>
      </button>
      <div class="side-wrapper mat-body-2">
        <p class="mat-title">{{ 'NAVBAR.MY_ACCOUNT' | translate }}</p>
        <hr />
        <div class="link-container">
          <p>
            <a
              routerLink="/navigation/account/address"
              routerLinkActive="active-tab"
              (click)="drawer.close()"
              [routerLinkActiveOptions]="{ exact: true }"
              >{{ 'DASHBOARD.ADDRESS_TITLE' | translate }}</a
            >
          </p>
          <p>
            <a
              routerLink="/navigation/account/payment-methods"
              routerLinkActive="active-tab"
              (click)="drawer.close()"
              [routerLinkActiveOptions]="{ exact: true }"
              >{{ 'DASHBOARD.PAYMENT_METHODS_TITLE' | translate }}</a
            >
          </p>
          <p>
            <a
              routerLink="/navigation/orders/dashboard"
              routerLinkActive="active-tab"
              (click)="drawer.close()"
              [routerLinkActiveOptions]="{ exact: true }"
              >{{ 'DASHBOARD.ORDERS' | translate }}</a
            >
          </p>
          <p>
            <a (click)="changePassword(); drawer.close()">{{
              'DASHBOARD.CHANGE_CREDENTIALS_DESCRIPTION' | translate
            }}</a>
          </p>
          <p *ngIf="environment.onlineSubscriptionLink">
            <a (click)="redirectToOnlineSubscriptions(); drawer.close()">
              <ng-container *ngIf="environment.customer === 'Res Publica'; else defaultText"
                ><span class="primary-color-text">zum Cicero E-Paper</span></ng-container
              >
              <ng-template #defaultText>{{ 'DASHBOARD.ONLINE_SUBSCRIPTIONS_DESCRIPTION' | translate }}</ng-template>
            </a>
          </p>
          <p *ngIf="environment.onlineSubscriptionLink && environment.digitalContent">
            <a (click)="redirectToExternalWebReader(); drawer.close()">{{
              'DASHBOARD.WEB_READER_DESCRIPTION' | translate
            }}</a>
          </p>
        </div>
      </div>
    </mat-drawer>
  </mat-drawer-container>
  <mat-divider></mat-divider>
  <footer class="footer">
    <div *ngIf="showTranslation" class="language-switch">
      <button mat-button color="primary" (click)="switchToLanguage('de')">Deutsch</button>
      <mat-divider [vertical]="true"></mat-divider>
      <button mat-button color="primary" (click)="switchToLanguage('en')">English</button>
      <mat-divider [vertical]="true"></mat-divider>
      <button mat-button color="primary" (click)="switchToLanguage('fr')">Français</button>
    </div>
    <h1 *ngIf="footerHeader" class="footer-header">{{ footerHeader }}</h1>
    <div class="footer-interior">
      <div class="left-footer-items">
        @for (footerObject of leftFooterItems; track footerObject) {
        <div class="footer-part left-footer-part">
          @if (footerObject.header) {
          <h2>{{ footerObject.header | translate : { company: environment.company } }}</h2>
          }
          @if (linedFooter) { <hr /> }
          @for (footerElement of footerObject.elements; track footerElement) {
          <div class="footer-element" [class.has-top-margin]="$first">
            @switch (footerElement.type) { @case ('link') {
            <a target="_blank" href="{{ footerElement.linkHref }}">{{ footerElement.textToDisplay }}</a>
            } @case ('text') {
            <span>{{ footerElement.textToDisplay }}</span>
            } @case ('html') {
            <span [innerHTML]="footerElement.html"></span>
            } } @if (!$last && linedFooter) {
            <hr />
            }
          </div>
          }
        </div>
        }
      </div>
      <div style="flex: 1">
        <div *ngFor="let footerObject of rightFooterItems" class="footer-part">
          <h2 *ngIf="footerObject.header">{{ footerObject.header }}</h2>
          <div *ngFor="let footerElement of footerObject.elements" class="footer-element">
            <a *ngIf="footerElement.type === 'link'" target="_blank" href="{{ footerElement.linkHref }}">{{
              footerElement.textToDisplay
            }}</a>
            <span *ngIf="footerElement.type === 'text'">{{ footerElement.textToDisplay }}</span>
            <span *ngIf="footerElement.type === 'html'" [innerHTML]="footerElement.html"></span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
